function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.prevButton) {
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
    }

    if (this.nextButton) {
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sourceSection = this.dataset.originalSection || this.dataset.section;
    return fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${sourceSection}`)
      .then((response) => {
        if (!response.ok) throw new Error('Variant section request failed');
        return response.text();
      })
      .then((responseText) => {
        if (this.currentVariant?.id !== requestedVariantId) return;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (!html.getElementById(`price-${sourceSection}`)) throw new Error('Variant section is incomplete');
        ['price', 'Sku', 'Inventory'].forEach((id) => {
          const destination = document.getElementById(`${id}-${this.dataset.section}`);
          const source = html.getElementById(`${id}-${sourceSection}`);
          if (!source || !destination) return;
          destination.innerHTML = source.innerHTML;
          destination.hidden = source.hidden;
          destination.classList.remove('visibility-hidden');
        });

        const delivery = html.querySelector('[data-ap-delivery-time]');
        if (delivery) {
          document.querySelectorAll('[data-ap-delivery-tab]').forEach((target) => {
            target.textContent = delivery.textContent.trim().replace(/^Lieferzeit:\s*/i, '');
          });
        }
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      })
      .catch(() => {
        if (this.currentVariant?.id !== requestedVariantId) return;
        window.location.assign(`${this.dataset.url}?variant=${requestedVariantId}`);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button?.querySelector('[name="add"]');
    const addButtonText = button?.querySelector('[name="add"] > span');
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    ['price', 'Sku', 'Inventory'].forEach((id) => {
      document.getElementById(`${id}-${this.dataset.section}`)?.classList.add('visibility-hidden');
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


class GallerySection {
  constructor(container) {
    this.container = container;

    if (!this.container) return;

    this.gallery = this.container.querySelector('.gallery--mobile-carousel');
    this.handleResize = debounce(this.updateCarousel.bind(this), 150);

    this.init();
  }

  init() {
    if (!this.gallery) return;

    if (!window.jQuery || !window.jQuery.fn.slick) {
      console.warn(
        'Gallery carousel requires jQuery and Slick Slider to be loaded.'
      );
      return;
    }

    this.updateCarousel();
    window.addEventListener('resize', this.handleResize);
    this.setHiddenHeights();
  }

  updateCarousel() {
    const $ = window.jQuery;
    const $gallery = $(this.gallery);

    const shouldShowCarousel = window.innerWidth < 768;
    const isCarousel = $gallery.hasClass('slick-initialized');

    if (!shouldShowCarousel) {
      $gallery
        .find('.lazyload--manual')
        .removeClass('lazyload--manual')
        .addClass('lazyload');
    }

    if (isCarousel && !shouldShowCarousel) {
      this.destroyCarousel();
      this.createRows();
    } else if (!isCarousel && shouldShowCarousel) {
      this.removeRows();
      this.createCarousel();
    }

    this.setHiddenHeights();
  }

  createCarousel() {
    const $ = window.jQuery;
    const $gallery = $(this.gallery);

    $gallery
      .addClass(
        'slick--overlay-transitions slick-slider--overlay-dots'
      )
      .on('init.gallerySection', function () {
        $(this)
          .find('.lazyload--manual')
          .removeClass('lazyload--manual')
          .addClass('lazyload');

        $(this)
          .find('.gallery__item-1')
          .addClass(
            'slick-slide--transition-enable slick-slide--transition-start'
          );

        $(this)
          .find('.slick-cloned')
          .removeClass(
            'slick-slide--transition-enable slick-slide--transition-start'
          );
      })
      .on(
        'beforeChange.gallerySection',
        function (event, slick, currentSlide, nextSlide) {
          const $nextSlide = $(slick.$slides[nextSlide]);

          $nextSlide.removeClass(
            'slick-slide--transition-enable slick-slide--transition-start'
          );

          const movingForward =
            nextSlide === currentSlide + 1 ||
            (nextSlide === 0 &&
              currentSlide === slick.slideCount - 1);

          $(this)
            .toggleClass('slick--transition-right', movingForward)
            .toggleClass('slick--transition-left', !movingForward);

          const isCloneTransition =
            (nextSlide === 0 && currentSlide !== 2) ||
            (nextSlide === slick.slideCount - 1 &&
              currentSlide === 0);

          const delay = Math.max(
            0,
            isCloneTransition
              ? slick.options.speed
              : slick.options.speed - 150
          );

          window.setTimeout(() => {
            $nextSlide.addClass('slick-slide--transition-enable');

            window.setTimeout(() => {
              $nextSlide.addClass('slick-slide--transition-start');
            }, 20);
          }, delay);
        }
      )
      .on(
        'afterChange.gallerySection',
        function (event, slick, currentSlide) {
          $(slick.$slides[currentSlide])
            .siblings()
            .removeClass(
              'slick-slide--transition-enable slick-slide--transition-start'
            );
        }
      )
      .slick({
        autoplay: false,
        fade: false,
        speed: 500,
        infinite: true,
        useTransform: true,
        arrows: false,
        dots: true
      });
  }

  destroyCarousel() {
    const $ = window.jQuery;
    const $gallery = $(this.gallery);

    if ($gallery.hasClass('slick-initialized')) {
      $gallery.slick('unslick');
    }

    $gallery.off('.gallerySection');

    $gallery
      .find('a, .gallery__item')
      .removeAttr('tabindex role');

    $gallery
      .find(
        '.slick-slide--transition-enable, .slick-slide--transition-start'
      )
      .removeClass(
        'slick-slide--transition-enable slick-slide--transition-start'
      );

    $gallery.removeClass(
      'slick--overlay-transitions slick-slider--overlay-dots slick--transition-left slick--transition-right'
    );
  }

  createRows() {
    const $ = window.jQuery;
    const $gallery = $(this.gallery);
    const rowLimit = Number($gallery.data('grid')) || 3;

    $gallery.children('.gallery__row').each(function () {
      $(this).children('.gallery__item').appendTo($gallery);
      $(this).remove();
    });

    let $currentRow = null;

    $gallery.children('.gallery__item').each(function (index) {
      if (index % rowLimit === 0) {
        $currentRow = $('<div class="gallery__row"></div>');
        $gallery.append($currentRow);
      }

      $currentRow.append(this);
    });
  }

  removeRows() {
    const $ = window.jQuery;
    const $gallery = $(this.gallery);

    $gallery.find('.gallery__row .gallery__item').appendTo($gallery);
    $gallery.find('.gallery__row').remove();
  }

  setHiddenHeights() {
    this.container
      .querySelectorAll(
        '.overlay--v-bottom .gallery__transition-el__inner'
      )
      .forEach((element) => {
        const overlay = element.closest('.overlay-text__inner');

        if (overlay) {
          overlay.style.transform = `translateY(-${element.offsetHeight}px)`;
        }
      });

    this.container
      .querySelectorAll(
        '.overlay--v-center .gallery__transition-el__inner'
      )
      .forEach((element) => {
        const overlay = element.closest('.overlay-text__inner');

        if (overlay) {
          overlay.style.transform =
            `translateY(-${Math.round(element.offsetHeight / 2)}px)`;
        }
      });
  }

  selectBlock(block) {
    const $ = window.jQuery;
    const $slider = $(block).closest('.slick-slider');

    if (!$slider.length || !$slider.hasClass('slick-initialized')) {
      return;
    }

    const slideIndex = Number($(block).attr('data-slick-index'));

    if (!Number.isNaN(slideIndex)) {
      $slider.slick('slickGoTo', slideIndex);
    }
  }

  destroy() {
    window.removeEventListener('resize', this.handleResize);

    if (window.jQuery && window.jQuery.fn.slick) {
      this.destroyCarousel();
    }
  }
}

class LegacySlideshowSection {
  constructor(container) {
    this.container = container;

    if (!this.container) return;

    this.slideshows = this.container.querySelectorAll('.slideshow');
    this.handleResize = debounce(this.assessFullHeightItems.bind(this), 150);

    this.init();
  }

  init() {
    if (!window.jQuery) {
      console.warn('Slideshow requires jQuery to be loaded.');
      return;
    }

    if (!window.jQuery.fn.slick) {
      console.warn('Slideshow requires Slick Slider to be loaded.');
      return;
    }

    this.initializeSlideshows();

    if (this.container.querySelector('.height--full')) {
      this.isFirstSection =
        this.container.closest('.shopify-section')?.previousElementSibling === null;

      this.assessFullHeightItems();
      window.addEventListener('resize', this.handleResize);
    }
  }

  initializeSlideshows() {
    const $ = window.jQuery;

    this.slideshows.forEach((slideshow) => {
      const $slideshow = $(slideshow);

      if ($slideshow.hasClass('slick-initialized')) return;

      const transition = $slideshow.data('slideshow-transition');
      const interval =
        parseInt($slideshow.data('slideshow-interval'), 10) || 5000;

      $slideshow
        .on('init.legacySlideshow', function () {
          $('.lazyload--manual', this)
            .removeClass('lazyload--manual')
            .addClass('lazyload');

          $('.slick-cloned', this).removeClass(
            'slick-slide--transition-enable slick-slide--transition-start'
          );
        })
        .on(
          'beforeChange.legacySlideshow',
          function (event, slick, currentSlide, nextSlide) {
            const $nextSlide = $(slick.$slides[nextSlide]);

            $nextSlide.removeClass(
              'slick-slide--transition-enable slick-slide--transition-start'
            );

            const movingForward =
              nextSlide === currentSlide + 1 ||
              (nextSlide === 0 &&
                currentSlide === slick.slideCount - 1);

            $(this)
              .toggleClass('slick--transition-right', movingForward)
              .toggleClass('slick--transition-left', !movingForward);

            const isCloneTransition =
              (nextSlide === 0 && currentSlide !== 2) ||
              (nextSlide === slick.slideCount - 1 &&
                currentSlide === 0);

            const delay = Math.max(
              0,
              isCloneTransition
                ? slick.options.speed
                : slick.options.speed - 150
            );

            window.setTimeout(() => {
              $nextSlide.addClass('slick-slide--transition-enable');

              window.setTimeout(() => {
                $nextSlide.addClass('slick-slide--transition-start');
              }, 20);
            }, delay);
          }
        )
        .on(
          'afterChange.legacySlideshow',
          function (event, slick, currentSlide) {
            $(slick.$slides[currentSlide])
              .siblings()
              .removeClass(
                'slick-slide--transition-enable slick-slide--transition-start'
              );
          }
        )
        .slick({
          autoplay: $slideshow.hasClass('auto-play'),
          autoplaySpeed: interval,
          fade: transition === 'fade',
          speed: transition === 'instant' ? 0 : 500,
          infinite: true,
          useTransform: true,
          arrows: true,
          dots: false,

          prevArrow: `
            <button
              type="button"
              class="slick-prev"
              aria-label="Previous slide"
            >
              ‹
            </button>
          `,

          nextArrow: `
            <button
              type="button"
              class="slick-next"
              aria-label="Next slide"
            >
              ›
            </button>
          `,

          responsive: [
            {
              breakpoint: 768,
              settings: {
                fade: false,
                arrows: false,
                dots: true
              }
            }
          ]
        });
    });
  }

  assessFullHeightItems() {
    let headerOffset = 0;
    const pageHeader =
      document.querySelector('.page-header') ||
      document.querySelector('.header-wrapper');

    if (pageHeader) {
      const position = window.getComputedStyle(pageHeader).position;

      if (this.isFirstSection || position === 'fixed' || position === 'sticky') {
        headerOffset = pageHeader.offsetHeight;
      }
    }

    this.container.querySelectorAll('.height--full').forEach((element) => {
      element.style.height = `calc(100vh - ${headerOffset}px)`;
    });
  }

  selectBlock(block) {
    const $ = window.jQuery;
    const $slider = $(block).closest('.slick-slider');

    if (!$slider.length || !$slider.hasClass('slick-initialized')) return;

    const slideIndex = Number($(block).attr('data-slick-index'));

    if (!Number.isNaN(slideIndex)) {
      $slider
        .slick('slickGoTo', slideIndex)
        .slick('slickPause');
    }
  }

  deselectBlock(block) {
    const $ = window.jQuery;
    const $slider = $(block).closest('.slick-slider');

    if (!$slider.length || !$slider.hasClass('slick-initialized')) return;

    $slider.slick('slickPlay');
  }

  destroy() {
    const $ = window.jQuery;

    window.removeEventListener('resize', this.handleResize);

    if (!$ || !$.fn.slick) return;

    this.slideshows.forEach((slideshow) => {
      const $slideshow = $(slideshow);

      if ($slideshow.hasClass('slick-initialized')) {
        $slideshow.slick('unslick');
      }

      $slideshow.off('.legacySlideshow');
    });
  }
}

const legacySlideshowSections = new Map();

function initializeLegacySlideshowSection(section) {
  if (!section || legacySlideshowSections.has(section)) return;

  const slideshow = section.querySelector('.slideshow');
  if (!slideshow) return;

  legacySlideshowSections.set(
    section,
    new LegacySlideshowSection(section)
  );
}

function initializeAllLegacySlideshows(container = document) {
  container
    .querySelectorAll('.shopify-section')
    .forEach(initializeLegacySlideshowSection);
}

document.addEventListener('DOMContentLoaded', () => {
  initializeAllLegacySlideshows();
});

document.addEventListener('shopify:section:load', (event) => {
  initializeLegacySlideshowSection(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  const instance = legacySlideshowSections.get(event.target);

  if (!instance) return;

  instance.destroy();
  legacySlideshowSections.delete(event.target);
});

document.addEventListener('shopify:block:select', (event) => {
  const section = event.target.closest('.shopify-section');
  const instance = section
    ? legacySlideshowSections.get(section)
    : null;

  if (instance) {
    instance.selectBlock(event.target);
  }
});

document.addEventListener('shopify:block:deselect', (event) => {
  const section = event.target.closest('.shopify-section');
  const instance = section
    ? legacySlideshowSections.get(section)
    : null;

  if (instance) {
    instance.deselectBlock(event.target);
  }
});

const gallerySections = new Map();

function initializeGallerySection(section) {
  if (!section || gallerySections.has(section)) return;

  const gallery = section.querySelector('.gallery--mobile-carousel');
  if (!gallery) return;

  gallerySections.set(section, new GallerySection(section));
}

function initializeAllGallerySections(container = document) {
  container
    .querySelectorAll('.shopify-section')
    .forEach(initializeGallerySection);
}

document.addEventListener('DOMContentLoaded', () => {
  initializeAllGallerySections();
});

document.addEventListener('shopify:section:load', (event) => {
  initializeGallerySection(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  const instance = gallerySections.get(event.target);

  if (!instance) return;

  instance.destroy();
  gallerySections.delete(event.target);
});

document.addEventListener('shopify:block:select', (event) => {
  const section = event.target.closest('.shopify-section');
  const instance = section ? gallerySections.get(section) : null;

  if (instance) {
    instance.selectBlock(event.target);
  }
});
